import React from 'react';
import { useTranslation } from 'react-i18next';
import { InputAdornment, MenuItem } from '@mui/material';
import { Select } from '../../../../app/form/select/select';
import { scenarioIllustrations } from '../../../icons/scenario-icons';
import { ScenarioType } from '../../../../../utils/compound-interest/types';
import { useCompoundInterestCalculatorContext } from '../../calculator-context/compound-interest-calculator-context';

export const CompoundInterestScenarioSelectMobile: React.FC = () => {
    const { t } = useTranslation();
    const { activeScenario, allTabs, scenarioLabels, handleScenarioChange } = useCompoundInterestCalculatorContext();

    const ScenarioIcon = scenarioIllustrations[activeScenario];

    return (
        <div className="mb-[2rem] block xl:hidden [&_.MuiInputLabel-root]:!left-[6.2rem] [&_.MuiSelect-select]:!pl-[0.8rem]">
            <Select
                label={t('pages.compoundInterest.scenarios.title')}
                value={activeScenario}
                onChange={(event) =>
                    handleScenarioChange(
                        (event as unknown as React.ChangeEvent<{ value: unknown }>)?.target.value as ScenarioType,
                    )
                }
                startAdornment={
                    <InputAdornment position="start" className="ml-[1rem] [&_svg]:h-[3.2rem] [&_svg]:w-[3.2rem]">
                        <ScenarioIcon />
                    </InputAdornment>
                }
                renderValue={() => scenarioLabels[activeScenario]}
                fullWidth
            >
                {allTabs.map((tab) => {
                    const OptionIcon = scenarioIllustrations[tab.id];
                    return (
                        <MenuItem key={tab.id} value={tab.id}>
                            <span className="mr-[1.2rem] shrink-0 [&_svg]:h-[3.2rem] [&_svg]:w-[3.2rem]">
                                <OptionIcon />
                            </span>
                            <span className="whitespace-normal">
                                {scenarioLabels[tab.id]} — {t('pages.compoundInterest.scenarios.returnLabel')}{' '}
                                {tab.interestRate}%, {t('pages.compoundInterest.scenarios.inflationLabel')}{' '}
                                {tab.inflationRate}%
                            </span>
                        </MenuItem>
                    );
                })}
            </Select>
        </div>
    );
};
